import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlacklistComponent } from './blacklist/blacklist.component';
import { LayoutModule } from '../shared/layout/layout.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ManualImportContactsComponent } from './manual-import-contacts/manual-import-contacts.component';
import { BlacklistTableComponent } from './blacklist-table/blacklist-table.component';
import { blacklistRoutes } from './blacklist.routes';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule
} from '@angular/material';
import { BlacklistService } from './blacklist/blacklist.service';
import { BlacklistResolve } from './blacklist/blacklist.resolve';
import { StoreModule } from '@ngrx/store';
import { blacklistReducer } from './blacklist/blacklist.reducer';
import { EffectsModule } from '@ngrx/effects';
import { BlacklistEffects } from './blacklist/blacklist.effects';
import { BlacklistTableDataSource } from './blacklist-table/blacklist-table.data';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ChooseComponent } from './choose/choose.component';
import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    RouterModule.forChild(blacklistRoutes),
    TranslateModule,
    MatTableModule,
    StoreModule.forFeature('blacklist', blacklistReducer),
    EffectsModule.forFeature([BlacklistEffects]),
    MatCheckboxModule,
    MatButtonModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatSortModule,
    NgxPermissionsModule,
    MatIconModule
  ],
  declarations: [BlacklistComponent, ManualImportContactsComponent, BlacklistTableComponent, ChooseComponent],
  exports: [BlacklistComponent],
  entryComponents: [BlacklistComponent],
  providers: [BlacklistService, BlacklistResolve, BlacklistTableDataSource]
})
export class BlacklistModule {}
